import React from "react";
import { View, StyleSheet } from "react-native";
import NtModalUnactiveButton from "./NtModalUnactiveButton";
import NtModalActiveButton from "./NtModalActiveButton";
import NtModalTitle from "./NtModalTitle";
import NtModalSubtitle from "./NtModalSubtitle";

function NtModalConirmAlert({ title, message, onCancel, onAccept }) {
  return (
    <View style={styles.container}>
      <NtModalTitle>{title}</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>{message}</NtModalSubtitle>

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={"OK"}
          onPress={() => {
            if (onAccept) onAccept();
          }}
          enabled={true}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
});

export default NtModalConirmAlert;
